// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-wrapper .logotype {
    display: flex;
    align-items: center;
}

.main-wrapper .logotype .logo-icon {

    height: 40px;
    width: 60px;
}

.main-wrapper .logotype .logo-text {
    max-width: 80px;
}

.main-wrapper .logotype span {
    color: #000;
    font-size: 22px;
    font-weight: 700;
    overflow: hidden;
    transition: width .7s;
    display: inline-block;
    margin-left: 5px;
}

.main-wrapper .sidebar .menuWrapper {
    display: block;
}

.main-wrapper .menuWrapper {
    padding-top: 0;
    padding-bottom: 0;
}

.menuWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
}

.main-wrapper .logo-hamburger-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 9px 9px 26px;
    border-bottom: 1px solid #eaecf0;
    min-height: 67px;
    background-color: var(--white);
}

.main-wrapper .hamburger-menu:hover {
    background-color: #f2f2f2;
}

.main-wrapper .hamburger-menu {
    background-color: transparent;
    width: 48px;
    height: 48px;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s linear;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-wrapper .hamburger-menu span {
    display: block;
    height: 1.5pt;
    background-color: #667085;
    border-radius: 32px;
    margin: 0;
    position: relative;
    width: 18px;
}

.main-wrapper .hamburger-menu span:after,
.main-wrapper .hamburger-menu span:before {
    background: #667085;
    content: "";
    display: block;
    height: 1.5pt;
    left: 50%;
    margin-left: -9px;
    position: absolute;
    top: 10%;
    transform: rotate(0deg);
    transition: all 0.4s cubic-bezier(0.6, 0, 0.2, 1);
    transition-delay: 0s;
    transition-timing-function: cubic-bezier(0.6, 0, 0.2, 1);
    width: 18px;
    border-radius: 32px;
}

.main-wrapper .hamburger-menu span:before {
    margin-top: -6px;
    top: 0;
}

.main-wrapper .hamburger-menu span:after {
    margin-top: 6px;
    top: 0;
}

.menu-wrapperBox {
    height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    left: 2px;
    padding-top: 8px;
    padding-bottom: 8px;
    background-color: var(--white);
}

.menu-wrapperBox::-webkit-scrollbar-thumb {
    border-radius: 6px;
    padding: 5px;
    background-color: #EAECF0;
}

/* Handle on hover */
.menu-wrapperBox::-webkit-scrollbar-thumb:hover {
    background-color: #f2f2f2;
}

.menu-wrapperBox::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #f9fafc;
}

.menu-wrapperBox::-webkit-scrollbar {
    height: 5px;
    background-color: #f9fafc;
    width: 6px;
}

.main-wrapper .sidebar,
.main-wrapper .sidebar .menuList,
.main-wrapper .sidebar .menuWrapper {
    display: block;
}

.main-wrapper .sidebar .menuList li:not(:last-child) {
    margin-bottom: 5px;
    /* your desired spacing */
}

.menuList {
    display: flex;
    align-items: center;
    padding-inline-start: 0;
    line-height: 2em;
}

.main-wrapper .sidebar nav .menuList .menuData>li {
    margin: 0 0 1px;
}

.main-wrapper .sidebar .menuList .order-count-item.menuListItem {
    justify-content: space-between;
}

.main-wrapper .sidebar .menuList .menuListItem {
    width: calc(100% - 55px);
    display: flex;
    align-items: center;
    padding: 10px;
    color: #344054;
    font-size: 14px;
    font-weight: 500;
    gap: 12px;
    border-radius: 6px;
    line-height: 24px;
    transition: background-color 0.3s ease;
    margin: 0 auto;
}

.main-wrapper .sidebar .menuList .order-count-item .menuListItem {
    padding: 0;
    margin: 0;
}

/* Ensure font-weight changes are instant for better performance */
.main-wrapper .sidebar nav .menuList .menuListItem:hover,
.main-wrapper .sidebar nav .menuList .menuListItem:active {
    transition: background-color 0.3s ease;
}

.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive,
.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive span {
    color: #101828;
    font-weight: 600;
}

.menuItemActive {
    background: var(--bg-green);
}

.totalOrderPlaceCount {
    background-color: #d92d20;
    border-radius: 100%;
    color: white !important;
    font-size: 12px !important;
    height: 28px;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive,
.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive span {
    color: var(--white);
}

.main-wrapper .sidebar nav .menuList>li:not(:has(.submenu:hover))>.menuListItem:hover,
.main-wrapper .sidebar nav .menuList .submenu .menuListItem:hover {
    background-color: var(--bg-green);
    color: var(--white) !important;
    font-weight: 600 !important;
}

.main-wrapper .sidebar nav .menuList>li:not(:has(.submenu:hover))>.menuListItem:hover span,
.main-wrapper .sidebar nav .menuList .submenu .menuListItem:hover span {
    color: var(--white) !important;
    font-weight: 600;
}

.main-wrapper .sidebar nav .menuList .submenu .menuListItem {
    margin: 0;
}

.menuList>li:hover:has(.submenu:hover)>.pages-menuListItem {
    background-color: transparent !important;
}

.has-submenu .submenu .menuListItem.menuItemActive a {
    color: var(--white);
    font-weight: 600;
}

.main-wrapper .sidebar .has-submenu .submenu .menuListItem {
    width: calc(100% - 27px);
}

.sidebar .menuList .menuListItem {
    white-space: nowrap;
}

.main-wrapper .sidebar .menuList .menuListItem>img {
    margin-right: 0;
    opacity: 0.7;
    width: 20px;
    position: relative;
    left: 2px;
}

.main-wrapper .sidebar .menuList .menuListItem.menuItemActive>img {
    opacity: 1;
}

.menuListItem>img {
    transition: opacity 0.2s ease;
}

.main-wrapper .sidebar .menuList .menuListItem span {
    transition: width 0.7s;
}

.main-wrapper .sidebar .menuList .menuListItem span {
    color: #344054;
    font-size: 16px;
    font-weight: 500;
}

.main-wrapper .user-action {
    border-top: 1px solid #eaecf0;
    padding: 0;
    width: calc(100% - 24px);
    min-height: 67px;
    display: none;
    justify-content: space-between;
    align-items: stretch;
    margin: 0 auto;
    background-color: var(--white);
}

.main-wrapper .user-action .menuRight {
    width: 100%;
    align-items: center;
    padding: 0 16px;
}

.menuRight {
    display: flex;
}

.main-wrapper .user-action .userProfile {
    width: 100%;
    justify-content: center;
}

.main-wrapper .user-action .userProfile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
}

.main-wrapper .user-action .userProfile .avatarVisible {
    margin-left: 0;
    align-items: center;
    width: 100%;
}

.avatarVisible {
    display: flex;
    align-items: center;
    margin-left: 15px;
}

.main-wrapper .sidebar-user {
    line-height: 1;
}

.main-wrapper .sidebar-user .avatar {
    padding-right: 0;
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50px;
}

.avatarVisible .avatar {
    margin-right: 0;
    padding-right: 15px;
}

.avatarVisible img {
    cursor: pointer;
}

.main-wrapper .user-action .userProfile .avatarVisible .sidebar-user-content {
    margin-left: 12px;
    width: 199px;
    max-width: 100%;
    height: 36px;
    transition: width 0.7s;
    overflow: hidden;
}

.main-wrapper .user-action .userProfile .avatarVisible .sidebar-user-content {
    margin-left: 12px;
    width: 199px;
    max-width: 100%;
    height: 36px;
    transition: width 0.7s;
    overflow: hidden;
}

.sidebar-user-name {
    color: #344054;
    /* font-family: Inter; */
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    width: 199px;
    margin: 0;
}

.sidebar-user-mail {
    color: #667085;
    font-size: 14px;
    line-height: 16px;
    word-break: break-word;
    margin: 0;
}

.sidebar-logout {
    width: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.hide-menu .main-wrapper .user-action .userProfile .avatarVisible {
    align-items: center;
}

.hide-menu .sidebar-user-content {
    margin-left: 15px;
}

.hide-menu .main-wrapper .addNew {
    margin: 24px 20px 10px;
}

a {
    text-decoration: none;
}

.submenu {
    max-height: 0;
    overflow: hidden;
    opacity: 1;
    margin: 5px 0;
    transition:
        max-height 0.8s ease,
        margin 0.5s ease
}

.has-submenu {
    cursor: pointer;
}

.has-submenu.open .submenu {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0px);
    list-style: none;
    padding-left: 70px;
}

.has-submenu .submenu {
    list-style: none;
    padding-left: 70px;
    margin: 0;
}

.has-submenu .submenu a {
    color: #000;
}

.has-submenu .arrow {
    display: inline-block;
    margin-left: auto;
    border: solid #555;
    border-width: 0 2px 2px 0;
    padding: 3px;
    transform: rotate(45deg);
    transition: transform 0.3s ease;
}

.has-submenu.open .arrow {
    transform: rotate(-135deg);
}

/* Orders button style */
.has-submenu>button.menuListItem {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    color: inherit;
    padding: 12px 15px;
}

.main-wrapper .main-content {
    margin-top: 67px;
}

.main-content-login {
    width: 100%;
}


@media screen and (min-width: 1025px) {

    .main-wrapper {
        display: flex;
        min-height: 100vh;
    }

    .main-wrapper .sidebar {
        width: 312px;
        border-right: 1px solid #eaecf0;
        min-height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9;
        overflow: hidden;
        transition-property: width, transform, opacity;
        transition-duration: 1s;
        transition-delay: 0.06s;
        transition-timing-function: cubic-bezier(0.74, 0.215, 0.125, 1.02);
    }

    .main-wrapper .main-content {
        left: 312px;
        position: relative;
        transition: left 599ms cubic-bezier(.74, .215, .125, 1.02), right 599ms cubic-bezier(.74, .215, .125, 1.02) !important;
        width: calc(100% - 312px);
        top: 67px;
        margin-top: 0;
    }

    .main-wrapper .topbar-container {
        left: 312px;
        position: fixed;
        transition: left 599ms cubic-bezier(.74, .215, .125, 1.02), right 599ms cubic-bezier(.74, .215, .125, 1.02) !important;
        width: calc(100% - 312px);
        margin-top: 0;
    }

    .hide-menu .logo-hamburger-menu .logotype {
        font-size: 0;
    }

    .hover-menu .logo-hamburger-menu .logotype span {
        width: 100px;
        transition: width .7s;
    }

    .hide-menu .logo-hamburger-menu .logotype span {
        transition: width .7s;
        width: 0;
    }

    .hide-menu .main-content,
    .hide-menu .topbar-container {
        left: 100px;
        width: calc(100% - 100px);
    }

    .hover-menu .menuWrapper .logotype span {
        transition: width .7s;
        width: 100px;
    }

    .hide-menu .sidebar {
        width: 100px;
    }

    .hide-menu .hamburger-menu {
        display: none;
    }

    .hide-menu .main-wrapper .sidebar nav .menuList .menuListItem span {
        overflow: hidden;
        width: 0;
    }

    .hide-menu .user-action .sidebar-logout {
        display: none;
    }

    .hover-menu.sidebar {
        transition-delay: 0s;
        width: 312px;
        z-index: 10;
    }

    .hover-menu .sidebar-text-box .sidebar-social-list,
    .hover-menu .user-action .sidebar-logout {
        display: flex;
    }

    .hover-menu .hamburger-menu {
        display: flex;
    }

    .hide-menu .main-wrapper .hover-menu.sidebar nav .menuList .menuListItem span {
        width: 120px;
    }

    .hide-menu .main-wrapper .hover-menu.sidebar nav .menuList .order-count-item.menuListItem .totalOrderPlaceCount {
        max-width: 28px;
        width: 28px;
        min-width: 28px
    }

    .hover-menu .sidebar-text-box h6,
    .hover-menu .sidebar-text-box p,
    .hover-menu .sidebar-user-content {
        display: block;
    }

    .main-wrapper .logo-hamburger-menu.mobile-view {
        display: none;
    }
}

@media screen and (max-width: 1024px) {
    .main-wrapper .user-action {
        display: flex;
    }

    .menu-wrapperBox {
        height: calc(100vh - 134px);
    }

    .sidebar {
        position: fixed;
        width: 100%;
        z-index: 6;
        top: 0;
        background: #fff;
    }

    .main-wrapper:has(.uploadMediaPopup) .sidebar {
        z-index: 0;
    }

    body.hide-menu {
        height: 100%;
        overflow: hidden;
        position: fixed;
        width: 100%;
    }

    .menu-wrapperBox {
        height: calc(100dvh - 130px);
        left: 0;
        width: 100%;
    }

    .main-wrapper .logo-hamburger-menu.mobile-view {
        padding: 9px 12px;
    }

    .main-wrapper .logo-hamburger-menu .logotype {
        padding-left: 10px;
    }

    .main-wrapper .hamburger-menu {
        height: 35px;
        width: 35px;
    }

    .hide-menu .main-wrapper .hamburger-menu span:before {
        margin-top: 0;
        transform: rotate(135deg);
    }

    .hide-menu .main-wrapper .hamburger-menu span:after {
        margin-top: 0;
        transform: rotate(-135deg);
    }

    .hide-menu .main-wrapper .hamburger-menu span {
        background: transparent !important;
        transition-delay: .1s;
        transition-duration: .2s;
    }

    .hide-menu .main-wrapper .main-content {
        left: calc(100% - 60px);
    }

    #myNav {
        border-right: 1px solid #eaecf0;
        height: 100%;
        left: 0;
        position: fixed;
        right: 0;
        top: 67px;
        transform: translateX(-100%);
        transition: all 799ms cubic-bezier(.74, .215, .125, 1.02);
        transition-delay: .06s;
        transition-duration: .7s;
        transition-timing-function: cubic-bezier(.74, .215, .125, 1.02);
        width: calc(100% - 60px);
        z-index: 99999;
        background-color: var(--white);
    }

    .hide-menu #myNav {
        box-shadow: 0 8px 8px -4px rgba(16, 24, 40, .03), 0 20px 24px -4px rgba(16, 24, 40, .08);
        transform: translateX(0);
    }

    .main-wrapper .logo-hamburger-menu.desktop-view {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,UAAU;IACV,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,iDAAiD;IACjD,oBAAoB;IACpB,wDAAwD;IACxD,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,eAAe;IACf,MAAM;AACV;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA,kEAAkE;AAClE;;IAEI,sCAAsC;AAC1C;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;IACjC,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb;;;AAGJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;;AAGA;;IAEI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,+BAA+B;QAC/B,iBAAiB;QACjB,eAAe;QACf,OAAO;QACP,MAAM;QACN,UAAU;QACV,gBAAgB;QAChB,8CAA8C;QAC9C,uBAAuB;QACvB,uBAAuB;QACvB,kEAAkE;IACtE;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,sHAAsH;QACtH,yBAAyB;QACzB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,sHAAsH;QACtH,yBAAyB;QACzB,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;QACrB,QAAQ;IACZ;;IAEA;;QAEI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,YAAY;QACZ,WAAW;IACf;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,WAAW;QACX;IACJ;;IAEA;;;QAGI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,UAAU;QACV,MAAM;QACN,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,4BAA4B;QAC5B,OAAO;QACP,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QAEb,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QAEb,0BAA0B;IAC9B;;IAEA;QACI,kCAAkC;QAClC,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,+BAA+B;QAC/B,YAAY;QACZ,OAAO;QACP,eAAe;QACf,QAAQ;QACR,SAAS;QAET,4BAA4B;QAC5B,yDAAyD;QACzD,sBAAsB;QACtB,wBAAwB;QACxB,+DAA+D;QAC/D,wBAAwB;QACxB,cAAc;QACd,8BAA8B;IAClC;;IAEA;QACI,wFAAwF;QAExF,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".main-wrapper .logotype {\n    display: flex;\n    align-items: center;\n}\n\n.main-wrapper .logotype .logo-icon {\n\n    height: 40px;\n    width: 60px;\n}\n\n.main-wrapper .logotype .logo-text {\n    max-width: 80px;\n}\n\n.main-wrapper .logotype span {\n    color: #000;\n    font-size: 22px;\n    font-weight: 700;\n    overflow: hidden;\n    transition: width .7s;\n    display: inline-block;\n    margin-left: 5px;\n}\n\n.main-wrapper .sidebar .menuWrapper {\n    display: block;\n}\n\n.main-wrapper .menuWrapper {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.menuWrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.main-wrapper .logo-hamburger-menu {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 9px 9px 9px 26px;\n    border-bottom: 1px solid #eaecf0;\n    min-height: 67px;\n    background-color: var(--white);\n}\n\n.main-wrapper .hamburger-menu:hover {\n    background-color: #f2f2f2;\n}\n\n.main-wrapper .hamburger-menu {\n    background-color: transparent;\n    width: 48px;\n    height: 48px;\n    outline: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    transition: all 0.3s linear;\n    border-radius: 50%;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.main-wrapper .hamburger-menu span {\n    display: block;\n    height: 1.5pt;\n    background-color: #667085;\n    border-radius: 32px;\n    margin: 0;\n    position: relative;\n    width: 18px;\n}\n\n.main-wrapper .hamburger-menu span:after,\n.main-wrapper .hamburger-menu span:before {\n    background: #667085;\n    content: \"\";\n    display: block;\n    height: 1.5pt;\n    left: 50%;\n    margin-left: -9px;\n    position: absolute;\n    top: 10%;\n    transform: rotate(0deg);\n    transition: all 0.4s cubic-bezier(0.6, 0, 0.2, 1);\n    transition-delay: 0s;\n    transition-timing-function: cubic-bezier(0.6, 0, 0.2, 1);\n    width: 18px;\n    border-radius: 32px;\n}\n\n.main-wrapper .hamburger-menu span:before {\n    margin-top: -6px;\n    top: 0;\n}\n\n.main-wrapper .hamburger-menu span:after {\n    margin-top: 6px;\n    top: 0;\n}\n\n.menu-wrapperBox {\n    height: calc(100vh - 80px);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: relative;\n    left: 2px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    background-color: var(--white);\n}\n\n.menu-wrapperBox::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    padding: 5px;\n    background-color: #EAECF0;\n}\n\n/* Handle on hover */\n.menu-wrapperBox::-webkit-scrollbar-thumb:hover {\n    background-color: #f2f2f2;\n}\n\n.menu-wrapperBox::-webkit-scrollbar-track {\n    border-radius: 5px;\n    background-color: #f9fafc;\n}\n\n.menu-wrapperBox::-webkit-scrollbar {\n    height: 5px;\n    background-color: #f9fafc;\n    width: 6px;\n}\n\n.main-wrapper .sidebar,\n.main-wrapper .sidebar .menuList,\n.main-wrapper .sidebar .menuWrapper {\n    display: block;\n}\n\n.main-wrapper .sidebar .menuList li:not(:last-child) {\n    margin-bottom: 5px;\n    /* your desired spacing */\n}\n\n.menuList {\n    display: flex;\n    align-items: center;\n    padding-inline-start: 0;\n    line-height: 2em;\n}\n\n.main-wrapper .sidebar nav .menuList .menuData>li {\n    margin: 0 0 1px;\n}\n\n.main-wrapper .sidebar .menuList .order-count-item.menuListItem {\n    justify-content: space-between;\n}\n\n.main-wrapper .sidebar .menuList .menuListItem {\n    width: calc(100% - 55px);\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    color: #344054;\n    font-size: 14px;\n    font-weight: 500;\n    gap: 12px;\n    border-radius: 6px;\n    line-height: 24px;\n    transition: background-color 0.3s ease;\n    margin: 0 auto;\n}\n\n.main-wrapper .sidebar .menuList .order-count-item .menuListItem {\n    padding: 0;\n    margin: 0;\n}\n\n/* Ensure font-weight changes are instant for better performance */\n.main-wrapper .sidebar nav .menuList .menuListItem:hover,\n.main-wrapper .sidebar nav .menuList .menuListItem:active {\n    transition: background-color 0.3s ease;\n}\n\n.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive,\n.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive span {\n    color: #101828;\n    font-weight: 600;\n}\n\n.menuItemActive {\n    background: var(--bg-green);\n}\n\n.totalOrderPlaceCount {\n    background-color: #d92d20;\n    border-radius: 100%;\n    color: white !important;\n    font-size: 12px !important;\n    height: 28px;\n    width: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive,\n.main-wrapper .sidebar nav .menuList .menuListItem.menuItemActive span {\n    color: var(--white);\n}\n\n.main-wrapper .sidebar nav .menuList>li:not(:has(.submenu:hover))>.menuListItem:hover,\n.main-wrapper .sidebar nav .menuList .submenu .menuListItem:hover {\n    background-color: var(--bg-green);\n    color: var(--white) !important;\n    font-weight: 600 !important;\n}\n\n.main-wrapper .sidebar nav .menuList>li:not(:has(.submenu:hover))>.menuListItem:hover span,\n.main-wrapper .sidebar nav .menuList .submenu .menuListItem:hover span {\n    color: var(--white) !important;\n    font-weight: 600;\n}\n\n.main-wrapper .sidebar nav .menuList .submenu .menuListItem {\n    margin: 0;\n}\n\n.menuList>li:hover:has(.submenu:hover)>.pages-menuListItem {\n    background-color: transparent !important;\n}\n\n.has-submenu .submenu .menuListItem.menuItemActive a {\n    color: var(--white);\n    font-weight: 600;\n}\n\n.main-wrapper .sidebar .has-submenu .submenu .menuListItem {\n    width: calc(100% - 27px);\n}\n\n.sidebar .menuList .menuListItem {\n    white-space: nowrap;\n}\n\n.main-wrapper .sidebar .menuList .menuListItem>img {\n    margin-right: 0;\n    opacity: 0.7;\n    width: 20px;\n    position: relative;\n    left: 2px;\n}\n\n.main-wrapper .sidebar .menuList .menuListItem.menuItemActive>img {\n    opacity: 1;\n}\n\n.menuListItem>img {\n    transition: opacity 0.2s ease;\n}\n\n.main-wrapper .sidebar .menuList .menuListItem span {\n    transition: width 0.7s;\n}\n\n.main-wrapper .sidebar .menuList .menuListItem span {\n    color: #344054;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.main-wrapper .user-action {\n    border-top: 1px solid #eaecf0;\n    padding: 0;\n    width: calc(100% - 24px);\n    min-height: 67px;\n    display: none;\n    justify-content: space-between;\n    align-items: stretch;\n    margin: 0 auto;\n    background-color: var(--white);\n}\n\n.main-wrapper .user-action .menuRight {\n    width: 100%;\n    align-items: center;\n    padding: 0 16px;\n}\n\n.menuRight {\n    display: flex;\n}\n\n.main-wrapper .user-action .userProfile {\n    width: 100%;\n    justify-content: center;\n}\n\n.main-wrapper .user-action .userProfile {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 auto;\n}\n\n.main-wrapper .user-action .userProfile .avatarVisible {\n    margin-left: 0;\n    align-items: center;\n    width: 100%;\n}\n\n.avatarVisible {\n    display: flex;\n    align-items: center;\n    margin-left: 15px;\n}\n\n.main-wrapper .sidebar-user {\n    line-height: 1;\n}\n\n.main-wrapper .sidebar-user .avatar {\n    padding-right: 0;\n    width: 40px;\n    height: 40px;\n    object-fit: cover;\n    border-radius: 50px;\n}\n\n.avatarVisible .avatar {\n    margin-right: 0;\n    padding-right: 15px;\n}\n\n.avatarVisible img {\n    cursor: pointer;\n}\n\n.main-wrapper .user-action .userProfile .avatarVisible .sidebar-user-content {\n    margin-left: 12px;\n    width: 199px;\n    max-width: 100%;\n    height: 36px;\n    transition: width 0.7s;\n    overflow: hidden;\n}\n\n.main-wrapper .user-action .userProfile .avatarVisible .sidebar-user-content {\n    margin-left: 12px;\n    width: 199px;\n    max-width: 100%;\n    height: 36px;\n    transition: width 0.7s;\n    overflow: hidden;\n}\n\n.sidebar-user-name {\n    color: #344054;\n    /* font-family: Inter; */\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    width: 199px;\n    margin: 0;\n}\n\n.sidebar-user-mail {\n    color: #667085;\n    font-size: 14px;\n    line-height: 16px;\n    word-break: break-word;\n    margin: 0;\n}\n\n.sidebar-logout {\n    width: 20px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.hide-menu .main-wrapper .user-action .userProfile .avatarVisible {\n    align-items: center;\n}\n\n.hide-menu .sidebar-user-content {\n    margin-left: 15px;\n}\n\n.hide-menu .main-wrapper .addNew {\n    margin: 24px 20px 10px;\n}\n\na {\n    text-decoration: none;\n}\n\n.submenu {\n    max-height: 0;\n    overflow: hidden;\n    opacity: 1;\n    margin: 5px 0;\n    transition:\n        max-height 0.8s ease,\n        margin 0.5s ease\n}\n\n.has-submenu {\n    cursor: pointer;\n}\n\n.has-submenu.open .submenu {\n    max-height: 500px;\n    opacity: 1;\n    transform: translateY(0px);\n    list-style: none;\n    padding-left: 70px;\n}\n\n.has-submenu .submenu {\n    list-style: none;\n    padding-left: 70px;\n    margin: 0;\n}\n\n.has-submenu .submenu a {\n    color: #000;\n}\n\n.has-submenu .arrow {\n    display: inline-block;\n    margin-left: auto;\n    border: solid #555;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    transform: rotate(45deg);\n    transition: transform 0.3s ease;\n}\n\n.has-submenu.open .arrow {\n    transform: rotate(-135deg);\n}\n\n/* Orders button style */\n.has-submenu>button.menuListItem {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: inherit;\n    padding: 12px 15px;\n}\n\n.main-wrapper .main-content {\n    margin-top: 67px;\n}\n\n.main-content-login {\n    width: 100%;\n}\n\n\n@media screen and (min-width: 1025px) {\n\n    .main-wrapper {\n        display: flex;\n        min-height: 100vh;\n    }\n\n    .main-wrapper .sidebar {\n        width: 312px;\n        border-right: 1px solid #eaecf0;\n        min-height: 100vh;\n        position: fixed;\n        left: 0;\n        top: 0;\n        z-index: 9;\n        overflow: hidden;\n        transition-property: width, transform, opacity;\n        transition-duration: 1s;\n        transition-delay: 0.06s;\n        transition-timing-function: cubic-bezier(0.74, 0.215, 0.125, 1.02);\n    }\n\n    .main-wrapper .main-content {\n        left: 312px;\n        position: relative;\n        transition: left 599ms cubic-bezier(.74, .215, .125, 1.02), right 599ms cubic-bezier(.74, .215, .125, 1.02) !important;\n        width: calc(100% - 312px);\n        top: 67px;\n        margin-top: 0;\n    }\n\n    .main-wrapper .topbar-container {\n        left: 312px;\n        position: fixed;\n        transition: left 599ms cubic-bezier(.74, .215, .125, 1.02), right 599ms cubic-bezier(.74, .215, .125, 1.02) !important;\n        width: calc(100% - 312px);\n        margin-top: 0;\n    }\n\n    .hide-menu .logo-hamburger-menu .logotype {\n        font-size: 0;\n    }\n\n    .hover-menu .logo-hamburger-menu .logotype span {\n        width: 100px;\n        transition: width .7s;\n    }\n\n    .hide-menu .logo-hamburger-menu .logotype span {\n        transition: width .7s;\n        width: 0;\n    }\n\n    .hide-menu .main-content,\n    .hide-menu .topbar-container {\n        left: 100px;\n        width: calc(100% - 100px);\n    }\n\n    .hover-menu .menuWrapper .logotype span {\n        transition: width .7s;\n        width: 100px;\n    }\n\n    .hide-menu .sidebar {\n        width: 100px;\n    }\n\n    .hide-menu .hamburger-menu {\n        display: none;\n    }\n\n    .hide-menu .main-wrapper .sidebar nav .menuList .menuListItem span {\n        overflow: hidden;\n        width: 0;\n    }\n\n    .hide-menu .user-action .sidebar-logout {\n        display: none;\n    }\n\n    .hover-menu.sidebar {\n        transition-delay: 0s;\n        width: 312px;\n        z-index: 10;\n    }\n\n    .hover-menu .sidebar-text-box .sidebar-social-list,\n    .hover-menu .user-action .sidebar-logout {\n        display: flex;\n    }\n\n    .hover-menu .hamburger-menu {\n        display: flex;\n    }\n\n    .hide-menu .main-wrapper .hover-menu.sidebar nav .menuList .menuListItem span {\n        width: 120px;\n    }\n\n    .hide-menu .main-wrapper .hover-menu.sidebar nav .menuList .order-count-item.menuListItem .totalOrderPlaceCount {\n        max-width: 28px;\n        width: 28px;\n        min-width: 28px\n    }\n\n    .hover-menu .sidebar-text-box h6,\n    .hover-menu .sidebar-text-box p,\n    .hover-menu .sidebar-user-content {\n        display: block;\n    }\n\n    .main-wrapper .logo-hamburger-menu.mobile-view {\n        display: none;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .main-wrapper .user-action {\n        display: flex;\n    }\n\n    .menu-wrapperBox {\n        height: calc(100vh - 134px);\n    }\n\n    .sidebar {\n        position: fixed;\n        width: 100%;\n        z-index: 6;\n        top: 0;\n        background: #fff;\n    }\n\n    .main-wrapper:has(.uploadMediaPopup) .sidebar {\n        z-index: 0;\n    }\n\n    body.hide-menu {\n        height: 100%;\n        overflow: hidden;\n        position: fixed;\n        width: 100%;\n    }\n\n    .menu-wrapperBox {\n        height: calc(100dvh - 130px);\n        left: 0;\n        width: 100%;\n    }\n\n    .main-wrapper .logo-hamburger-menu.mobile-view {\n        padding: 9px 12px;\n    }\n\n    .main-wrapper .logo-hamburger-menu .logotype {\n        padding-left: 10px;\n    }\n\n    .main-wrapper .hamburger-menu {\n        height: 35px;\n        width: 35px;\n    }\n\n    .hide-menu .main-wrapper .hamburger-menu span:before {\n        margin-top: 0;\n        -webkit-transform: rotate(135deg);\n        transform: rotate(135deg);\n    }\n\n    .hide-menu .main-wrapper .hamburger-menu span:after {\n        margin-top: 0;\n        -webkit-transform: rotate(-135deg);\n        transform: rotate(-135deg);\n    }\n\n    .hide-menu .main-wrapper .hamburger-menu span {\n        background: transparent !important;\n        transition-delay: .1s;\n        transition-duration: .2s;\n    }\n\n    .hide-menu .main-wrapper .main-content {\n        left: calc(100% - 60px);\n    }\n\n    #myNav {\n        border-right: 1px solid #eaecf0;\n        height: 100%;\n        left: 0;\n        position: fixed;\n        right: 0;\n        top: 67px;\n        -webkit-transform: translateX(-100%);\n        transform: translateX(-100%);\n        transition: all 799ms cubic-bezier(.74, .215, .125, 1.02);\n        transition-delay: .06s;\n        transition-duration: .7s;\n        transition-timing-function: cubic-bezier(.74, .215, .125, 1.02);\n        width: calc(100% - 60px);\n        z-index: 99999;\n        background-color: var(--white);\n    }\n\n    .hide-menu #myNav {\n        box-shadow: 0 8px 8px -4px rgba(16, 24, 40, .03), 0 20px 24px -4px rgba(16, 24, 40, .08);\n        -webkit-transform: translateX(0);\n        transform: translateX(0);\n    }\n\n    .main-wrapper .logo-hamburger-menu.desktop-view {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
